/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const updateTypeBodyContainsMax = 200;

export const updateTypeBodyExpectedOutgoingRevisionMax = 128;

export const updateTypeBodyIncludesMax = 200;

export const updateTypeBodyRelatesToMax = 200;

export const updateTypeBodyTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const updateTypeBodyTypeDefinitionReferenceViewPredicatesMax = 10;

export const updateTypeBodyTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const updateTypeBodyTypeDefinitionReferenceViewSearchTermsMax = 10;

export const UpdateTypeBody = zod.object({
  contains: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(updateTypeBodyContainsMax)
    .optional(),
  expectedContentUuid: zod
    .uuid()
    .optional()
    .describe('Current TYPE version UUID from GET. Required when changing conformance.'),
  expectedOutgoingRevision: zod
    .string()
    .min(1)
    .max(updateTypeBodyExpectedOutgoingRevisionMax)
    .optional()
    .describe(
      'Outgoing revision from the same GET snapshot. Required when changing conformance; stale values reject with 409.',
    ),
  includes: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(updateTypeBodyIncludesMax)
    .optional(),
  performAs: zod
    .object({
      actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
    })
    .optional(),
  relatesTo: zod
    .array(
      zod.object({
        edgeDescription: zod
          .string()
          .nullish()
          .describe(
            'Free-text description of the edge, stored verbatim. Omit to keep the stored description of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); a NEW attachment that omits it stores none. null clears it.',
          ),
        edgeKey: zod
          .string()
          .nullish()
          .describe(
            'Schema field key (lower snake_case, letter first) for a CONTAINS\/INCLUDES edge between TYPEs. Omit to keep the stored key of an existing attachment (on PATCH, and on a create-graph command that re-asserts an existing parent\/target pair); only a NEW attachment that omits it derives the key from the target type name. null is rejected on CONTAINS\/INCLUDES on both commands (a schema field always has a key) and clears the key on RELATES_TO.',
          ),
        from: zod
          .string()
          .min(1)
          .optional()
          .describe(
            'Source node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. When omitted it defaults to the root (first) node on create, and to the TYPE being updated on PATCH \/types\/{uuid}.',
          ),
        max: zod.int().nullish().describe('Maximum cardinality (lowered to the edge maxCount).'),
        min: zod.int().nullish().describe('Minimum cardinality (lowered to the edge minCount).'),
        position: zod.int().nullish(),
        to: zod
          .string()
          .min(1)
          .describe(
            'Target node: an existing content UUID, or — on the create endpoints only — a node clientId from this request. A PATCH carries no nodes, so there it is always an existing UUID.',
          ),
      }),
    )
    .max(updateTypeBodyRelatesToMax)
    .optional(),
  typeDefinition: zod
    .object({
      conformance: zod.enum(['open', 'lax', 'strict']).optional(),
      description: zod.string().nullish(),
      enumOptions: zod
        .array(zod.string().min(1))
        .optional()
        .describe(
          'Ordered choice values for an ENUM type (one string per option). Stored as { value, label } with value === label.',
        ),
      file: zod
        .object({
          allowedFormats: zod
            .array(
              zod.enum([
                'pdf',
                'doc',
                'docx',
                'xls',
                'xlsx',
                'csv',
                'txt',
                'jpeg',
                'png',
                'webp',
                'gif',
                'heic',
                'md',
                'html',
                'mp3',
                'm4a',
                'wav',
                'mp4',
                'mov',
                'webm',
              ]),
            )
            .min(1)
            .optional(),
        })
        .nullish()
        .describe(
          'File config for a STRING type whose instances hold uploaded files. allowedFormats narrows the platform allowlist to a subset of format ids; omitted, the field accepts every platform-supported format. Pass null to clear a stored config; omit to keep it.',
        ),
      reference: zod
        .object({
          carbonCopy: zod.boolean().optional(),
          creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
          edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
          typeLineageUuid: zod.uuid(),
          typeUuid: zod.uuid(),
          view: zod
            .object({
              predicates: zod
                .array(
                  zod.object({
                    op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                    pathTypeUuids: zod
                      .array(zod.uuid())
                      .min(1)
                      .max(updateTypeBodyTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax),
                    value: zod.string().optional(),
                    valueType: zod
                      .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                      .optional(),
                  }),
                )
                .max(updateTypeBodyTypeDefinitionReferenceViewPredicatesMax)
                .optional(),
              searchTerms: zod
                .array(
                  zod
                    .string()
                    .min(1)
                    .max(updateTypeBodyTypeDefinitionReferenceViewSearchTermsItemMax),
                )
                .max(updateTypeBodyTypeDefinitionReferenceViewSearchTermsMax)
                .optional(),
            })
            .nullish(),
        })
        .nullish()
        .describe(
          "Reference config for a STRING type whose instances point at another TYPE's instances. Pass null to clear a stored config; omit to keep it.",
        ),
    })
    .optional(),
  typeName: zod
    .string()
    .min(1)
    .optional()
    .describe('New type name; omit to keep the stored value.'),
});

export type UpdateTypeBody = zod.input<typeof UpdateTypeBody>;
export type UpdateTypeBodyOutput = zod.output<typeof UpdateTypeBody>;
